import { render, staticRenderFns } from "./RetainUserPay.vue?vue&type=template&id=352fee28&"
import script from "./RetainUserPay.vue?vue&type=script&lang=js&"
export * from "./RetainUserPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports